import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = {
  key: 0,
  class: "border-b bg-gray-50 px-4 py-2 text-sm font-semibold"
}
const _hoisted_3 = { class: "grid sm:grid-cols-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "min-w-0 text-sm space-y-1 break-words" }
const _hoisted_8 = { class: "font-semibold break-words" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-wrap gap-3 pt-2"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "text-amber-800"
}
const _hoisted_14 = {
  key: 1,
  class: "text-blue-700"
}
const _hoisted_15 = {
  key: 1,
  class: "p-3 text-sm bg-white space-y-1"
}
const _hoisted_16 = {
  key: 0,
  class: "text-amber-800"
}
const _hoisted_17 = {
  key: 0,
  class: "text-amber-800"
}
const _hoisted_18 = {
  key: 1,
  class: "text-blue-700"
}

import type { ReplacementAppliedProduct, ReplacementLine, ReplacementSnapshot } from '@/api/remplacements';
import { replacementMoney, replacementLineProducts } from '@/api/remplacements';

export default /*@__PURE__*/_defineComponent({
  __name: 'ReplacementComparison',
  props: {
    lines: {},
    provisional: { type: Boolean },
    editable: { type: Boolean }
  },
  emits: ["edit"],
  setup(__props: any) {



function status(line: ReplacementLine) { return line.statut || (line.id_ligne_remplacement != null ? 'accepted' : 'pending'); }
function unavailable(line: ReplacementLine) { return ['rejected', 'expired', 'cancelled'].includes(status(line)); }
function displayProducts(line: ReplacementLine) {
  const products = replacementLineProducts(line);
  if (unavailable(line)) return [];
  return products;
}
function sides(line: ReplacementLine) { return [
  { key: 'origine', label: 'En rupture', products: [line.origine as ReplacementAppliedProduct] },
  { key: 'remplacement', label: status(line) === 'pending' ? 'Remplacements proposés' : status(line) === 'expired' ? 'Proposition expirée' : status(line) === 'cancelled' ? 'Proposition annulée' : status(line) === 'rejected' ? 'Remplacement refusé' : 'Remplacement confirmé', products: displayProducts(line) },
]; }
function sizes(product: ReplacementSnapshot) {
  return product.quantites.map((quantity, index) => quantity ? `${product.tailles[index] || 'Assortiment'} × ${quantity}` : '').filter(Boolean).join(' · ');
}
function quantity(product: ReplacementSnapshot) { return product.quantites.reduce((sum, q) => sum + q, 0); }
function hideImage(event: Event) { (event.target as HTMLImageElement).style.display = 'none'; }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line) => {
      return (_openBlock(), _createElementBlock("article", {
        key: line.id_ligne_origine,
        class: "rounded-lg border border-gray-200 overflow-hidden"
      }, [
        (line.id_commande)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
              _createTextVNode("Commande " + _toDisplayString(line.id_commande_groupe), 1),
              (line.nom_boutique)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" · " + _toDisplayString(line.nom_boutique), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sides(line), (side) => {
            return (_openBlock(), _createElementBlock("div", {
              key: side.key,
              class: _normalizeClass(["p-4 space-y-3", side.key === 'origine' ? 'bg-red-50' : unavailable(line) ? 'bg-gray-50' : status(line) === 'pending' ? 'bg-indigo-50' : 'bg-green-50'])
            }, [
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("span", {
                  class: _normalizeClass(["replacement-state inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase", side.key === 'origine' ? 'replacement-state--rupture' : unavailable(line) ? 'replacement-state--unavailable' : status(line) === 'pending' ? 'replacement-state--proposed' : 'replacement-state--confirmed'])
                }, _toDisplayString(side.label), 3)
              ]),
              (side.key === 'remplacement' && unavailable(line))
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Article maintenu en rupture."))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(side.products, (product) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: product.id_produit,
                  class: "flex gap-3"
                }, [
                  (product.image_url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: product.image_url,
                        alt: "",
                        class: "w-20 h-24 object-contain rounded bg-white",
                        referrerpolicy: "no-referrer",
                        onError: hideImage
                      }, null, 40, _hoisted_6))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", _hoisted_8, _toDisplayString(product.reference), 1),
                    _createElementVNode("p", null, _toDisplayString(product.couleur), 1),
                    _createElementVNode("p", null, _toDisplayString(sizes(product)), 1),
                    _createElementVNode("p", null, [
                      (side.key === 'origine' && product.vendu_par !== 'tailles')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(product.quantite_pack) + " paquet(s) · ", 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(quantity(product)) + " pièce(s)", 1)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_unref(replacementMoney)(product.montant_ht)) + " HT · " + _toDisplayString(_unref(replacementMoney)(product.montant_ttc)) + " TTC", 1),
                    (_ctx.editable && side.key === 'remplacement' && status(line) === 'pending')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-indigo-700 underline",
                            onClick: ($event: any) => (_ctx.$emit('edit', line, product, 'quantity'))
                          }, "Quantité", 8, _hoisted_10),
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-red-700 underline",
                            onClick: ($event: any) => (_ctx.$emit('edit', line, product, 'remove'))
                          }, "Annuler ce candidat", 8, _hoisted_11),
                          _createElementVNode("button", {
                            type: "button",
                            class: "text-indigo-700 underline",
                            onClick: ($event: any) => (_ctx.$emit('edit', line, product, 'product'))
                          }, "Changer de produit", 8, _hoisted_12)
                        ]))
                      : _createCommentVNode("", true),
                    (side.key === 'remplacement' && status(line) === 'pending')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (product.charge_vendeur_ttc)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Charge vendeur si choisi : " + _toDisplayString(_unref(replacementMoney)(product.charge_vendeur_ttc)) + " TTC", 1))
                            : (product.a_rembourser_ttc)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_14, "Remboursement estimé : " + _toDisplayString(_unref(replacementMoney)(product.a_rembourser_ttc)) + " TTC (hors remise fixe)", 1))
                              : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ], 2))
          }), 128))
        ]),
        (status(line) === 'pending' ? displayProducts(line).length > 1 : line.charge_vendeur_ttc > 0 || line.a_rembourser_ttc > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (status(line) === 'pending')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", null, _toDisplayString(displayProducts(line).length) + " produits · 1 au choix", 1),
                    (line.charge_vendeur_max_ttc)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, "Charge vendeur (max.) : " + _toDisplayString(_unref(replacementMoney)(line.charge_vendeur_max_ttc)) + " TTC", 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (line.charge_vendeur_ttc > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Charge vendeur : " + _toDisplayString(_unref(replacementMoney)(line.charge_vendeur_ttc)) + " TTC", 1))
                      : _createCommentVNode("", true),
                    (line.a_rembourser_ttc > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                          _createTextVNode(_toDisplayString(_ctx.provisional ? 'Remboursement estimé' : 'Remboursement prévu') + " : ", 1),
                          _createElementVNode("strong", null, _toDisplayString(_unref(replacementMoney)(line.a_rembourser_ttc)) + " TTC", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})